import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import { EntityForm } from '../../widgets/Forms';
import ViewUtils from '../../ViewUtils';
import { CustomCheckbox } from '../../widgets/CustomCheckbox';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const utils = new ViewUtils();

export const DGConfirmDetailsForm = React.forwardRef((props, ref) => {

    function ConfirmDetailsDisableCheck(value, contacts) {
        if (value !== undefined && value !== null) {
            if (contacts === 0) {
                return true
            }
            else if (value === true) {
                return true
            }
            else if (value !== true) {
                return false
            }
        }
    }

    return (
        <EntityForm ref={ref} 
            viewId="dgconfirm"
            dataURL='api/sims/dgorganisationcontact/GetConfirmDetails'
            values={props.data}
            entityLookupId={props.id}
            entityLookupController={props.entityLookupController} 
            org="saseta"
            useCustomSettings={false}
            valueChangeHandler={props.valueChangeHandler}>
            {form =>
                <form className={form.classes.container} id="dgorganisationDetailsForm">
                            <table cellPadding="2" width="80%" index={0}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <CustomCheckbox
                                                id="ConfirmDetails"
                                                parentId={0}
                                                form={form}
                                                disabled={ConfirmDetailsDisableCheck(form.values["ConfirmDetails"], form.values["HasContacts"])}
                                                InputProps={{
                                                    'aria-label': 'primary checkbox'

                                                }}
                                                label="Confirm Details"
                                            />
                                            <label id="HasContacts" visible={false}></label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                </form >
            }
        </EntityForm >
    );
})